// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ProgressBar_wrapper__J6SR","label":"ProgressBar_label__35iI","bar":"ProgressBar_bar__2YN9","percent":"ProgressBar_percent__S63Z"};


//////////////////
// WEBPACK FOOTER
// ./src/components/util/ProgressBar/ProgressBar.scss
// module id = 1058
// module chunks = 0